import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const StoreContext = createContext(null);
const LS_KEY = "petrolgiuly_store";

export function StoreProvider({ children }) {
  const { user } = useAuth();
  const [stores, setStores] = useState([]);
  const [storeId, setStoreIdState] = useState(localStorage.getItem(LS_KEY) || "all");
  const [loading, setLoading] = useState(true);

  const isSuperAdmin = user && user !== false && user.role === "super_admin";

  const load = useCallback(async () => {
    if (!user || user === false) return;
    setLoading(true);
    try {
      const { data } = await api.get("/stores", { params: { include_archived: false } });
      setStores(data);
      const saved = localStorage.getItem(LS_KEY);
      const valid = saved === "all" ? isSuperAdmin : data.some((s) => s.id === saved);
      if (!valid) {
        const def = isSuperAdmin ? "all" : (data[0]?.id || "");
        setStoreIdState(def);
        localStorage.setItem(LS_KEY, def);
      }
    } finally {
      setLoading(false);
    }
  }, [user, isSuperAdmin]);

  useEffect(() => { load(); }, [load]);

  const setStoreId = (id) => {
    setStoreIdState(id);
    localStorage.setItem(LS_KEY, id);
  };

  const currentStore = stores.find((s) => s.id === storeId) || null;

  return (
    <StoreContext.Provider value={{ stores, storeId, setStoreId, currentStore, isSuperAdmin, loading, reloadStores: load }}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  return useContext(StoreContext);
}
